<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div  class="header-navbar-shadow"></div>
    <div  v-if="!showKycGroup" class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="User"
              bc1="App"
              bc2="User"
              bc3="Profile"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- account setting page -->
        <section id="page-account-settings">
          <div class="row">
            <!-- left menu section -->
            <div class="col-md-3 mb-2 mb-md-0">
              <ul class="nav nav-pills flex-column nav-left">
                <!-- general -->
                <li class="nav-item" @click="currentTab = 1">
                  <a class="nav-link active" id="account-pill-general" data-toggle="pill" href="#account-vertical-general" aria-expanded="true">
                    <feather type="layers" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">General</span>
                  </a>
                </li>
                <li class="nav-item" @click="currentTab = 6">
                  <a class="nav-link"  data-toggle="pill" href="javascript:void(0)" @click="showKycGroup = true" aria-expanded="false">
                    <feather type="users" class="font-medium-3 mr-1 font-weight-bolder"></feather
                    >
                    <span class="font-weight-bold">Kyc Groups</span>
                  </a>
                </li>
              </ul>
            </div>
            <!--/ left menu section -->

            <!-- right content section -->
            <div class="col-md-9">
              <div class="card">
                <div class="card-body">
                  <div class="tab-content">
                    <!-- general tab -->
                    <div role="tabpanel" class="tab-pane active" id="account-vertical-general" aria-labelledby="account-pill-general" aria-expanded="true">
                      <!-- header media -->
                      <div class="media">
                        <a href="javascript:void(0);" class="mr-25">
                          <img :src="profileImage? profileImage: '/app-assets/images/portrait/small/avatar-user.png'" id="account-upload-img" class="rounded mr-50" alt="profile image" height="80" width="80" />
                        </a>
                        <!-- upload and reset button -->
<!--                        <div class="media-body mt-75 ml-1">-->
<!--                          <label for="account-upload" class="btn btn-sm btn-primary mb-75 mr-75">Upload</label>-->
<!--                          <input type="file" id="account-upload" hidden accept="image/*" />-->
<!--                          <button class="btn btn-sm btn-outline-secondary mb-75">Reset</button>-->
<!--                        </div>-->
                        <!--/ upload and reset button -->
                      </div>
                      <!--/ header media -->

                      <!-- form -->
                      <form class="validate-form mt-2">
                        <div class="row">
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-username">First Name</label>
                              <input type="text" class="form-control" id="account-username" name="username" v-model="firstName" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-name">Last Name</label>
                              <input type="text" class="form-control" id="account-name" name="name" v-model="lastName" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-e-mail">E-mail</label>
                              <input type="email" disabled class="form-control" id="account-e-mail" v-model="email" />
                            </div>
                          </div>
                          <div class="col-12 col-sm-6">
                            <div class="form-group">
                              <label for="account-company">Phone</label>
                              <input type="text" class="form-control" id="account-company" v-model="phone" />
                            </div>
                          </div>
                          <div class="col-12">
                            <button type="submit" class="btn btn-primary mt-2 mr-1 d-flex" :disabled="updateProfileLoader" @click="UpdateProfile">
                              <Loader :loading="updateProfileLoader" size="10px"></Loader>
                              Save changes
                            </button>
                          </div>
                        </div>
                      </form>
                      <!--/ form -->
                    </div>
                    <!--/ general tab -->

                    <div class="tab-pane fade" id="account-vertical-notifications" role="tabpanel" aria-labelledby="account-pill-notifications" aria-expanded="false">
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex align-items-center mb-2">
                            <i data-feather="link" class="font-medium-3"></i>
                            <h4 class="mb-0 ml-75">Groups</h4>
                          </div>
                        </div>
<!--                        <div class="table-responsive">-->
<!--                          <table class="table">-->
<!--                            <thead>-->
<!--                            <tr>-->
<!--                              <th class="py-1">S.No</th>-->
<!--                              <th class="py-1">Name</th>-->
<!--                              <th class="py-1">Code</th>-->
<!--                              <th class="py-1">Status</th>-->
<!--                            </tr>-->
<!--                            </thead>-->
<!--                            <tbody>-->
<!--                            <template v-for="(channelItem,channelIndex) in userGroups">-->
<!--                              <tr>-->
<!--                                <td class="py-1">-->
<!--                                  <span class="font-weight-bold">{{channelIndex+1}}</span>-->
<!--                                </td>-->
<!--                                <td class="py-1">-->
<!--                                  <span class="font-weight-bold">{{channelItem.name}}</span>-->
<!--                                </td>-->
<!--                                <td class="py-1">-->
<!--                                  <span class="font-weight-bold">{{channelItem.code}}</span>-->
<!--                                </td>-->
<!--                                <td class="py-1">-->
<!--                                  <span v-if="channelItem.status == 1" class="badge badge-success badge-glow badge-sm">Active</span>-->
<!--                                  <span v-else class="badge badge-danger badge-glow badge-sm">Inactive</span>-->
<!--                                </td>-->
<!--                              </tr>-->
<!--                            </template>-->
<!--                            </tbody>-->
<!--                          </table>-->
<!--                        </div>-->

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--/ right content section -->
          </div>
        </section>
        <!-- / account setting page -->

      </div>
    </div>
    <KycGroups usedFor="user" v-if="showKycGroup" @hideKycGroup="showKycGroup = false;currentTab = 1"></KycGroups>
  </div>
</template>

<script>

import KycGroups from "@/pages/dashboard/merchant/KycGroups";
export default {
  props: ['propFilters'],
  components:{
    KycGroups
  },
  mounted() {
    var merchantProfileData = this.$store.getters.getByKey(
        "userProfileData"
    );
    this.userId = merchantProfileData.row.id


    this.profileImage =  merchantProfileData.row.avatar
    this.firstName =  merchantProfileData.row.first_name
    this.lastName =  merchantProfileData.row.last_name
    this.email =  merchantProfileData.row.email
    this.phone =  merchantProfileData.row.phone_number
    this.uuid =  merchantProfileData.row.uuid

    // this.getUsersGroups()



  },
  data() {
    return {
      uuid:'',
      profileImage:'',
      firstName:'',
      lastName:'',
      email:'',
      phone:'',
      userId:'',
      userGroups:[],
      currentTab:1,
      updateProfileLoader: false,
      showKycGroup:false
    }
  },
  methods: {
    backTo(){
      let propFilters = this.propFilters
      this.$router.push({name:'app-users',params:{propFilters}})
    },
    UpdateProfile(){
      this.updateProfileLoader = true
      let data = {
        firstName:this.firstName,
        lastName:this.lastName,
        phoneNumber:this.phone,
        uuid:this.uuid
      }

      this.makeRequest("post", "v1/update-admin-user", data).then(
        callResponse => {
          this.updateProfileLoader = false
        }

      )
    },
    getUsersGroups(){
      this.makeRequest('post', 'v1/detail-merchant', {id: this.userId}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data){
              this.userGroups = data.groups
            }
          }
        }

      });
    },

  },
  watch:{
    // currentTab(val){
    //   if(val == 4){
    //     if(!this.channels.length){
    //       this.getMerchantGroups()
    //     }
    //   }else if(val == 2){
    //     this.showStore = 'v1/get-store'
    //   }
    //   else if(val == 3){
    //     this.showTerminal = 'v1/get-terminal'
    //   }
    // }
  }

}
</script>



